import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addUser, getUserRole, getUserStatus, getUserType, getUserTypeCategory, updateUser } from "../../../services/userMasterUser";
import {
  validEmail,
  validateFullName,
  validatePhone,
} from "../../../components/Regex";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addMasterLeadStatus, getLeadType, updateMasterLeadStatus } from "../../../services/leads";

export default function LeadStatusCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [leadTypeList, setLeadTypeList] = useState([])
  const [leadTypeIn, setLeadTypeIn] = useState([])

  const [input, setInput] = useState({
    leadType: state?.leadType || "", // dropdown
    status: state?.role || "", // input 
    role: state?.role || "ROLE_EMPLOYEE", // dropdown
    active: state?.active || true,
    category: state?.category || "openLead",
  });

  const [otherLeadType, setOtherLeadType] = useState("");

  const [errors, setErrors] = useState({
    leadType: "",
    status: "",
    role: "",
    active: "",
    category: "",
  });

  const [userStatusData, setUserStatusData] = useState();
  const [activeDataList, setActiveDataList] = useState([
    { label: "ACTIVE", value: true },
    { label: "INACTIVE", value: false },
  ]);
  const [categoryDataList, setCategoryDataList] = useState([
    { label: "Open Lead Status", value: "openLead" },
    { label: "Closed Lead Status", value: "closedLead" },
  ])
  const [userRoleData, setUserRoleData] = useState();
  const [userTypeData, setUserTypeData] = useState([])

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const fetchData = () => {

    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadType = response.data.map((item) => ({
            label: item,
            value: item,
          }));

          const OtherType = {
            label: "Other",
            value: "Other",
          }
          const dataList = [...leadType, OtherType]
          // add one more data other in this and open filed for input
          setLeadTypeList(dataList);
        }
      })
      .catch(() => errorMessage());

    getUserStatus()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const services = Res.map((item) => ({
            label: item,
            value: item,
          }));
          setUserStatusData(services);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getUserRole()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const filterRole = Res.filter((item) => item.roleName === "ROLE_TELECALLER" || item.roleName === "ROLE_OPERATION")
          const services = filterRole.map((item) => ({
            label: item.roleName,
            value: item.roleName,
          }));
          setUserRoleData(services);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });



    const typeData = {
      name: "",
      category: "",
      searchBy: "",
      searchText: ""
    };

    getUserType(typeData)
      .then((response) => {
        if (!response.data.error) {
          const userType = response.data.map((item) => ({
            label: item?.name,
            value: item?.id,
          }));
          setUserTypeData(userType)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!input.leadType) {
      newErrors.leadType = "Please Select Lead Type";
      isValid = false;
    } else {
      newErrors.leadType = "";
    }

    if (input.role === "") {
      newErrors.role = "Please Select Role";
      isValid = false;
    } else {
      newErrors.role = "";
    }

    if (input.status === "") {
      newErrors.status = "Please Enter Status";
      isValid = false;
    } else {
      newErrors.status = "";
    }

    if (input.active === "") {
      newErrors.active = "Please Select Active";
      isValid = false;
    } else {
      newErrors.active = "";
    }

    if (input.category === "") {
      newErrors.category = "Please Select Category";
      isValid = false;
    } else {
      newErrors.category = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          ...state,
          id: state.id,
          leadType: input.leadType === "Other" ? otherLeadType : input.leadType,
          role: input.role,
          status: input.status,
          active: input.active,
          category: input.category

        };
        updateMasterLeadStatus(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/lead-status/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          leadType: input.leadType === "Other" ? otherLeadType : input.leadType,
          role: input.role,
          status: input.status,
          active: input.active,
          category: input.category
        };
        addMasterLeadStatus(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/lead-status/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/lead-status/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Lead Status {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="leadType" className="form-label">
                        Lead Type
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={leadTypeList}
                        value={input.leadType}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            leadType: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.leadType}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="role" className="form-label">
                        Role
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={userRoleData}
                        value={input.role}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            role: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.role}</div>
                    </div>
                  </div>

                  {input.leadType === "Other" &&
                    <div className="row mb-3">


                      <div className="col-md-6">
                        <label htmlFor="otherLeadType" className="form-label">
                          Other Lead Type
                        </label>
                        <InputText
                          type="text"
                          style={{ width: "100%" }}
                          id="otherLeadType"
                          name="otherLeadType"
                          value={input.otherLeadType}
                          onChange={(e) => {
                            setOtherLeadType(e.target.value,);
                          }}
                          required
                        />
                        <div className="text-danger">{errors.otherLeadType}</div>
                      </div>
                    </div>}


                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="active" className="form-label">
                        Active
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={activeDataList}
                        value={input.active}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            active: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.active}</div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>

                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="status"
                        name="status"
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>

                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="category" className="form-label">
                        Status Category
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={categoryDataList}
                        value={input.category}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            category: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.category}</div>
                    </div>

                  </div>



                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
